define('ordersDetailDocumentsOrderView',[
  'app',
  'module',
  'underscore',
  'settings',
  'attachmentsView',
  'entities/customers/customers'
], function(
  App,
  Module,
  _,
  Settings,
  AttachmentsView
) {
  'use strict';

  Module.exports = AttachmentsView.extend({

    setConfig() {
      return {
        galleryTitle: 'Order Document',
        canCopy: Settings.configValue('order.attachments.showCustomerAttachments') ? true : false,
        copyButton: {
          title: _.i18n('orders.detail.attachments.order.copy-button.title')
        },
        canFlag: true,
        canAiEdit: true
      };
    },

    aiEditItem: function(attachment) {
      this.openAiEditChat(this.model.get('purchaseOrderId'), attachment);
    },

    fetch: function(first, pageSize) {
      return this.model.getDocuments(first, pageSize);
    },

    uploadItem: function(file) {
      return this.model.uploadDocument(file);
    },

    deleteItem(attachment) {
      return this.model.deleteDocument(attachment);
    },

    editItem: function(attachment) {
      App.navigate('attachments/attachments/' + this.model.get('secId') + '/' + attachment.get('secId') + '/commandline', {trigger: true});
    },

    copyItem: function(attachment) {
      this.model.copyDocumentToCustomer(attachment, this.options.customer.get('secId')).done(_.bind(function(newAttachment) {
        var model = App.request('customer:model', newAttachment);
        this.options.documentsView.customerView.addAttachment(model);
      }, this));
    }
  });
});

